import { memo, useMemo } from "react";

import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import {
  type Score,
  type RatingStat,
  type ProductReviewsSettings,
} from "@root/tablescape/state";
import { ReviewsSectionSummaryView } from "@sections/ProductReviews/ReviewsSectionSummary/ReviewsSectionSummary.view";

type Props = {
  distribution: Record<Score, number> | undefined;
  isAggregate: boolean;
  reviewCount: number | undefined;
  reviewScore: string | undefined;
};
const ReviewsSectionSummaryBase = ({
  distribution,
  isAggregate,
  reviewCount,
  reviewScore,
}: Props) => {
  const {
    settings: { theme },
  } = useSectionSettings<ProductReviewsSettings>();

  const ratingStat: RatingStat[] | undefined = useMemo(() => {
    const ratings: Score[] = ["5", "4", "3", "2", "1"];
    return distribution && reviewScore && reviewCount
      ? ratings.map((rating: Score) => {
          const count = distribution[rating];
          return {
            count: count.toLocaleString("en"),
            label: rating,
            percentage: Math.round((count / reviewCount) * 100),
          };
        })
      : undefined;
  }, [distribution, reviewScore, reviewCount]);

  return reviewCount && reviewScore && ratingStat ? (
    <ReviewsSectionSummaryView
      perScoreRatingStat={ratingStat}
      reviewCount={reviewCount.toLocaleString("en")}
      reviewScore={reviewScore}
      showBundleDisclaimer={isAggregate}
      theme={theme}
    />
  ) : (
    <></>
  );
};

export const ReviewsSectionSummary = memo(ReviewsSectionSummaryBase);
